module.exports = __webpack_public_path__ + "static/img/yangan.ca1bff89.png";